import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ComplianceNewComponent } from './pages/compliances/compliance-new/compliance-new.component';
import { CompliancesReportsComponent } from './pages/compliances/compliance-reports/compliances-reports.component';
import { CompliancesComponent } from './pages/compliances/compliances.component';
import { HistoriesReportsUploadComponent } from './pages/histories-safras/histories-safras-detail/histories-reports-upload/histories-reports-upload.component';
import { HistoriesSafrasDetailComponent } from './pages/histories-safras/histories-safras-detail/histories-safras-detail.component';
import { HistoriesSafrasUploadComponent } from './pages/histories-safras/histories-safras-detail/histories-safras-upload/histories-safras-upload.component';
import { HistoriesSafrasReportsComponent } from './pages/histories-safras/histories-safras-reports/histories-safras-reports.component';
import { HistoriesSafrasComponent } from './pages/histories-safras/histories-safras.component';
import { HistorySafraNewComponent } from './pages/histories-safras/history-safra-new/history-safra-new.component';
import { MonitoringSafraNewComponent } from './pages/monitoring-safras/monitoring-safra-new/monitoring-safra-new.component';
import { MonitoringPlotUploadComponent } from './pages/monitoring-safras/monitoring-plot-upload/monitoring-plot-upload.component';
import { MonitoringSafrasDetailComponent } from './pages/monitoring-safras/monitoring-safras-detail/monitoring-safras-detail.component';
import { MonitoringSafrasUploadComponent } from './pages/monitoring-safras/monitoring-safras-detail/monitoring-safras-upload/monitoring-safras-upload.component';
import { MonitoringSafrasComponent } from './pages/monitoring-safras/monitoring-safras.component';
import { LayoutPagesComponent } from './shared/components/layout-pages/layout-pages.component';
import { OrganizationsComponent } from './pages/organizations/organizations.component';
import { CreateOrganizationComponent } from './pages/organizations/create-organization/create-organization.component';
import { UsersComponent } from './pages/admin/users/users.component';
import { UserCreateComponent } from './pages/admin/users/user-create/user-create.component';
import { ContractListComponent } from './pages/adm/contract-list/contract-list.component';
import { ContractFormComponent } from './pages/adm/contract-form/contract-form.component';
import { ContractViewComponent } from './pages/adm/contract-view/contract-view.component';
import { OrganizationDetailsComponent } from './pages/organizations/organization-details/organization-details.component';
import { EditOrganizationComponent } from './pages/organizations/edit-organization/edit-organization.component';
import { MonitoringSafraResultsComponent } from './pages/monitoring-safras/monitoring-safra-results/monitoring-safra-results.component';
import { MonitoredAreaComponent } from './pages/monitoring-safras/monitoring-safra-results/table-monitoring-safra-results/monitored-area/monitored-area.component';
import { ContractSummaryDashboardComponent } from './pages/contract-summary-dashboard/contract-summary-dashboard.component';
import { InternalSummaryComponent } from './pages/admin/internal-summary/internal-summary.component';
import { ZarcSettingsComponent } from './pages/admin/zarc/zarc-settings.component';
import { isGeoambienteGuard } from './guards/is-geoamb.guard';
import { authGuard } from './guards/auth.guard';
import { canRequestGuard } from './guards/can-request.guard';
import { canAdminGuard } from './guards/can-admin.guard';
import { hasOrgGuard } from './guards/has-org.guard';
import { DatasafraAgentPage } from './pages/datasafra-agent/datasafra-agent';

export const routes: Routes = [
  { path: '', redirectTo: 'datasafra-agent', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    title: 'DataSafra | Entrar na Plataforma',
  },
  {
    path: '',
    component: LayoutPagesComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'datasafra-agent',
        component: DatasafraAgentPage,
        title: 'Agente DataSafra ᵇᵉᵗᵃ',
      },
      //dashboard
      {
        path: 'dashboard',
        component: ContractSummaryDashboardComponent,
        canActivate: [hasOrgGuard],
        title: 'Dashboard do Cliente',
      },
      // COMPLIANCES
      {
        path: 'compliances',
        children: [
          {
            path: '',
            component: CompliancesComponent,
            title: 'Solicitações de Compliance',
          },
          {
            path: 'new',
            component: ComplianceNewComponent,
            canActivate: [canRequestGuard],
            title: 'Solicitar Análise de Compliance',
          },
          {
            path: 'reports',
            component: CompliancesReportsComponent,
            title: 'Relatórios de Compliance Socioambiental',
          },
          {
            path: ':id/reports',
            component: CompliancesReportsComponent,
            title: (route) =>
              `Relatórios de Compliance Socioambiental - #${route.params['id']}`,
          },
        ],
      },
      // HISTORIES SAFRAS
      {
        path: 'histories-safras',
        children: [
          {
            path: '',
            component: HistoriesSafrasComponent,
            title: 'Solicitação de Histórico de Safras',
          },
          {
            path: 'new',
            component: HistorySafraNewComponent,
            canActivate: [canRequestGuard],
            title: 'Solicitar Histórico de Safras',
          },
          {
            path: 'reports',
            component: HistoriesSafrasReportsComponent,
            title: (r) =>
              `Relatório Histórico de Safras ${r.queryParams['batchRequestId'] ? `#${r.queryParams['batchRequestId']}` : ''}`,
          },
          {
            path: 'adm/detail/:id',
            component: HistoriesSafrasDetailComponent,
            canActivate: [isGeoambienteGuard],
            title: (r) => `Detalhes do Histórico de Safras #${r.params['id']}`,
          },
          {
            path: 'adm/detail/:id/upload-report',
            component: HistoriesReportsUploadComponent,
            canActivate: [isGeoambienteGuard],
            title: (r) => `Upload do Histórico de Safras #${r.params['id']}`,
          },
          {
            path: 'adm/detail/:id/upload',
            component: HistoriesSafrasUploadComponent,
            canActivate: [isGeoambienteGuard],
            title: (r) =>
              `Upload de Arquivo - Histórico de Safras #${r.params['id']}`,
          },
        ],
      },
      // MONITORING SAFRAS
      {
        path: 'monitoring-safras',
        children: [
          {
            path: '',
            component: MonitoringSafrasComponent,
            title: 'Solicitação de Monitoramento da Safra',
          },
          {
            path: 'new',
            component: MonitoringSafraNewComponent,
            canActivate: [canRequestGuard],
            title: 'Solicitação de Monitoramento da Safra',
          },
          {
            path: 'adm/detail/:id',
            component: MonitoringSafrasDetailComponent,
            canActivate: [isGeoambienteGuard],
            title: 'Detalhes do Monitoramento da Safra',
          },
          {
            path: 'adm/upload-plot/:id',
            component: MonitoringPlotUploadComponent,
            canActivate: [isGeoambienteGuard],
            title: (r) => `Upload de Talhões #${r.params['id']}`,
          },
          {
            path: 'adm/detail/:id/upload',
            component: MonitoringSafrasUploadComponent,
            canActivate: [isGeoambienteGuard],
            title: 'Upload de Arquivo - Monitoramento da Safra',
          },
          {
            path: 'results',
            component: MonitoringSafraResultsComponent,
            title: 'Resultados do Monitoramento da Safra',
          },
          {
            path: 'results/monitored-area/:idArea',
            data: { HIDE_GLOBAL_BACK_BUTTON: true },
            component: MonitoredAreaComponent,
            title: (route) => {
              const areaId = route.params['idArea'];
              const cropYear = route.queryParams['cropYear'];
              // Título conforme especificação: "Identificação da área: {areaId} | Safra {cropYear}"
              if (areaId && cropYear) {
                return `Identificação da área: ${areaId} | Safra ${cropYear}`;
              }
              if (areaId) {
                return `Identificação da área: ${areaId}`;
              }
              // Fallback se parâmetros ausentes
              return 'Identificação da área';
            },
          },
        ],
      },
      // ADMIN
      {
        path: 'admin',
        canActivate: [canAdminGuard],
        children: [
          {
            path: 'dashboard',
            component: InternalSummaryComponent,
            canActivate: [isGeoambienteGuard],
            title: 'Painel de Clientes',
          },
          {
            path: 'zarc',
            component: ZarcSettingsComponent,
            canActivate: [isGeoambienteGuard],
            title: 'Configuração do ZARC',
          },
          {
            path: 'organizations',
            children: [
              {
                path: '',
                component: OrganizationsComponent,
                title: 'Clientes',
              },
              {
                path: 'new',
                component: CreateOrganizationComponent,
                title: 'Novo Cliente',
              },
              {
                path: 'details/:id',
                component: OrganizationDetailsComponent,
                title: (r) => `Detalhes do Cliente - #${r.params['id']}`,
              },
              {
                path: 'edit/:id',
                component: EditOrganizationComponent,
                title: 'Editar Cliente',
              },
            ],
          },
          {
            path: 'contracts',
            children: [
              {
                path: '',
                component: ContractListComponent,
                title: 'Contratos',
              },
              {
                path: 'new',
                component: ContractFormComponent,
                title: 'Cadastrar Contrato',
              },
              {
                path: 'edit/:id',
                component: ContractFormComponent,
                title: 'Editar Contrato',
              },
              {
                path: 'view/:id',
                component: ContractViewComponent,
                title: 'Visualizar Contrato',
              },
            ],
          },
          {
            path: 'users',
            children: [
              {
                path: '',
                component: UsersComponent,
                title: 'Administração de Usuários',
              },
              {
                path: 'create',
                component: UserCreateComponent,
                title: 'Cadastrar Usuário',
              },
              {
                path: ':id',
                component: UserCreateComponent,
                title: 'Detalhes do Usuário',
              },
              {
                path: ':id/edit',
                component: UserCreateComponent,
                title: 'Editar Usuário',
              },
            ],
          },
        ],
      },
    ],
  },
];
